import { Box, Divider, Image, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"

import { IS_JEWLR } from "helpers/application"

import { ButtonLink, InputWrapper } from "../components"
import fetchOrderStatus from "../hoc/fetch-order-status"

import Contact from "./contact"
import Details from "./details"
import Intro from "./intro"
import Progress from "./progress"

const OrderStatus = ({ data, error, loading }) => {
  if (error) {
    return (
      <Box contain my={6}>
        <Typography color="error" mb={2}>
          {error}
        </Typography>
        <InputWrapper>
          <ButtonLink data-lc="status" to="/">
            Continue Shopping
          </ButtonLink>
        </InputWrapper>
      </Box>
    )
  }

  if (loading || !data) {
    return (
      <Box minHeight="350px" my={6} textAlign="center">
        <Image
          alt="Loading"
          height="175"
          lazyload={false}
          src={require("images/layout/loadinglarge.gif")}
          width="175"
        />
      </Box>
    )
  }

  return (
    <Box contain pb={4} px={2}>
      <Intro data={data} />
      <Divider
        bg="grey.20"
        display={{ _: "none", tablet: "block" }}
        mb={5}
        mt={2}
      />
      <Progress data={data} />
      <Divider bg="grey.20" my={{ _: 2, tablet: 3 }} />
      <Details data={data} />
      {IS_JEWLR() && <Contact />}
    </Box>
  )
}

OrderStatus.propTypes = {
  data: PropTypes.object,
  error: PropTypes.string,
  loading: PropTypes.bool,
}

export default fetchOrderStatus(OrderStatus)
